import ArtifactGroupType from "../base/ArtifactGroupType";


const IdolOfBastet = {
  id: '109',
  name: 'Idol Of Bastet',
  groupIcon: 'TreasuresOfTheNile',
  type: ArtifactGroupType.TREASURES_OF_THE_NILE,
  icon: 'IdolOfBastet',
  power: 25
};

export default IdolOfBastet;
